import classNames from 'classnames';
import { createComponent, ElementWithProps } from 'packages/components/src';
import Arrow from '~/icons/Arrow';

const Pulser = createComponent('div', {
  className: 'animate-pulse rounded-md bg-background-disabled-subtle'
});

export const SkeletonTextSmall = createComponent(Pulser, {
  className: 'h-16'
});

export const SkeletonTextMedium = createComponent(Pulser, {
  className: 'h-20 h-40'
});

const navBaseClasses =
  'flex items-center justify-center relative rounded-full sm:h-44 sm:w-44 md:h-48 md:w-48 border border-border-strong bg-background-default  fill-icon-strong';
const navHoverClasses = 'hover:bg-background-default-hover';
const navActiveClasses =
  'active:bg-background-default-active active:fill-icon-inverse active:border-transparent';
const navDisabledClasses =
  'disabled:bg-background-disabled-subtle disabled:border-border-disabled disabled:fill-icon-disabled-subtle';

export const CarouselNavBtn = createComponent<
  ElementWithProps<{ isSkeleton: boolean }>
>('button', props => ({
  className: classNames(
    `${navBaseClasses} ${navHoverClasses} ${navActiveClasses} ${navDisabledClasses}`,
    { 'animate-pulse !border-border-disabled': props.isSkeleton }
  )
}));

export const CarouselArrowIcon = createComponent<
  ElementWithProps<{ isSkeleton: boolean; isLeftArrow: boolean }>
>(Arrow, props => ({
  className: classNames('text-inherit w-24', {
    'animate-pulse fill-border-disabled': props.isSkeleton,
    'rotate-180': props.isLeftArrow
  })
}));
